import axiosInstance from "app/axiosInstance";

export const getGeozoneAssignedObjects = async ({
  accountId,
  geozoneId
}: {
  accountId: string;
  geozoneId: string;
}) => {
  try {
    const response = await axiosInstance.get(
      `/accounts/${accountId}/geozones/${geozoneId}/assigned-objects`
    );
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
